import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Nav } from "@/components/layout/Nav";
import { Footer } from "@/components/layout/Footer";
import { Background } from "@/components/layout/Background";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider, useTheme } from "@/context/ThemeProvider";
import { PAGE_ACCENTS, PAGE_ACCENTS_LIGHT } from "@/data/site";
import Home from "@/pages/Home";
import Agency from "@/pages/Agency";
import Apps from "@/pages/Apps";
import Lab from "@/pages/Lab";
import Work from "@/pages/Work";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AIAudit from "@/pages/AIAudit";

const Layout = () => {
  const { pathname } = useLocation();
  const { theme } = useTheme();
  const map = theme === "light" ? PAGE_ACCENTS_LIGHT : PAGE_ACCENTS;
  const accent = map[pathname] ?? map["/"];
  return (
    <div className="relative min-h-screen" style={{ "--page-accent": accent }}>
      <Background />
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

// Minimal layout for the AI Audit sales page (no nav, no footer -- page has its own footer)
const LayoutMinimal = () => {
  const { pathname } = useLocation();
  const { theme } = useTheme();
  const map = theme === "light" ? PAGE_ACCENTS_LIGHT : PAGE_ACCENTS;
  const accent = map[pathname] ?? map["/"];
  return (
    <div className="relative min-h-screen" style={{ "--page-accent": accent }}>
      <Background />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

const AppToaster = () => {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="bottom-right" />;
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Standard layout with Nav + Footer */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/agency" element={<Agency />} />
              <Route path="/apps" element={<Apps />} />
              <Route path="/lab" element={<Lab />} />
              <Route path="/work" element={<Work />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Route>
            {/* Minimal layout for AI Audit page (no nav) */}
            <Route element={<LayoutMinimal />}>
              <Route path="/ai-audit" element={<AIAudit />} />
            </Route>
          </Routes>
          <AppToaster />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
